// removed by extract-text-webpack-plugin
module.exports = {"signInContainer":"Signin__signInContainer___rs6Z3","loader":"Signin__loader___3dOTw","errorContainer":"Signin__errorContainer___fW0IQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Signin/Signin.scss
// module id = 1534
// module chunks = 0